import {
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Header,
  Link,
  SpaceBetween,
  Grid,
  // Button,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useEffect, useState, useContext, useCallback, useRef} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as awsui from "@cloudscape-design/design-tokens";
import { animated, useSpring } from "@react-spring/web";
import { useScroll } from '@use-gesture/react'
import { GlobalContext } from "../context";
import { useMediaQuery } from 'react-responsive';
import NewsStories from '../components/news-stories';
import Announcement from '../components/announcement';
import CurrentSeries from '../components/current-series';
import Icon from "@cloudscape-design/components/icon";
import { navigateFn } from "../routingHelper";
import { CustomButton } from "../components/buttons";


const InfiniteLooper = function InfiniteLooper({
  speed,
  direction,
  children,
}: {
  speed: number;
  direction: "right" | "left";
  children: React.ReactNode;
}) {
  const [looperInstances, setLooperInstances] = useState(1);
  const outerRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);

  function resetAnimation() {
    if (innerRef?.current) {
      innerRef.current.setAttribute("data-animate", "false");

      setTimeout(() => {
        if (innerRef?.current) {
          innerRef.current.setAttribute("data-animate", "true");
        }
      }, 10);
    }
  }
  const setupInstances = useCallback(() => {
    if (!innerRef?.current || !outerRef?.current) return;
    const { width } = innerRef.current.getBoundingClientRect();
    const { width: parentWidth } = outerRef.current.getBoundingClientRect();
    const widthDeficit = parentWidth - width;
    const instanceWidth = width / innerRef.current.children.length;
    if (widthDeficit) {
      setLooperInstances(
        looperInstances + Math.ceil(widthDeficit / instanceWidth) + 1
      );
    }
    resetAnimation();
  }, [looperInstances]);
  useEffect(() => setupInstances(), [setupInstances]);
  useEffect(() => {
    window.addEventListener("resize", setupInstances);
    return () => {
      window.removeEventListener("resize", setupInstances);
    };
  }, [looperInstances, setupInstances]);
  return (
    <div className="looper" ref={outerRef}>
      <div className="looper__innerList" ref={innerRef} data-animate="true">
        {[...Array(looperInstances)].map((_, ind) => (
          <div
            key={ind}
            className="looper__listInstance"
            style={{
              animationDuration: `${speed}s`,
              animationDirection: direction === "right" ? "reverse" : "normal",
            }}
          >
            {children}
          </div>
        ))}
      </div>
    </div>
  );
}


export default function Home() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    theme, setTheme, 
  } = useContext(GlobalContext);
  const [seriesStyle, setSeriesStyle] = useSpring(() => ({
    transform: "perspective(500px) rotateY(0deg)"
  }));
  const screenWidth_800 = useMediaQuery({query: "only screen and (max-width : 800px)"})
  const isSmallDevice = useMediaQuery({query: "only screen and (max-width : 768px)"});
  const isMediumDevice = useMediaQuery({query: "only screen and (min-width : 769px) and (max-width : 992px)"});
  const isLargeDevice = useMediaQuery({query: "only screen and (min-width : 993px) and (max-width : 1200px)"});
  const isDesktop = useMediaQuery({query: "only screen and (min-width : 1201px)"});


  const HeroLogo = () => {
    return (
      <>
        <div 
          className="home-hero-logo-container" 
          style={{ 
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            paddingTop: "20px",
            maxWidth: "500px",
            minWidth: "300px",
            zIndex: "3",
          }}
        >
          <img
            className="home-hero-logo-img"
            src="/images/FRG_NAVY_BLUE.png"
            alt="FRG Hero Logo"
          />
        </div>
      </>
    )
  }

  const imgArray2180 = [
    "/images/hero/2180_1.png",
    "/images/hero/2180_2.png",
    "/images/hero/2180_3.png"
  ]
  const imgArray1200 = [
    "/images/hero/1200_1.png",
    "/images/hero/1200_2.png",
    "/images/hero/1200_3.png"
  ]
  const imgArray900 = [
    "/images/hero/900_1.png",
    "/images/hero/900_2.png",
    "/images/hero/900_3.png"
  ]
  const imgArray700 = [
    "/images/hero/700_1.png",
    "/images/hero/700_2.png",
    "/images/hero/700_3.png"
  ]
  const imgArray400 = [
    "/images/hero/400_1.png",
    "/images/hero/400_2.png",
    "/images/hero/400_3.png"
  ]

  function getRandomImage(imgArray: string[]) {
    var num = Math.floor( Math.random() * imgArray.length );
    return imgArray[ num ];
  }

  if (screenWidth_800){
    console.log("screen is less than 800 pixels")
  }

  
  const HeroImg = () => {
    let heroImg = getRandomImage(imgArray2180)
    if (isSmallDevice){
      heroImg = getRandomImage(imgArray700)
    } else if (isMediumDevice){
      heroImg = getRandomImage(imgArray900)
    } else if (isLargeDevice){
      heroImg = getRandomImage(imgArray1200)
    } 
    return (
      <>
        <div 
          className="home-hero-container" 
          style={{ 
            filter: "opacity(70%)",
            backgroundImage: `url('${heroImg}')`,
            height: "40vh",
            maxHeight: "450px",
            width: "100%",
            zIndex: "2",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }} 
        />
      </>
    )
  }

  return (
    <>
      <center>
        <div style={{position: "relative", background: "black"}}>
          {/* <HeroLogo /> */}
            <div style={{
              position: "absolute",
              bottom: "10px",
              left: "50%",
              transform: "translateX(-50%)",
              textAlign:"center",
              paddingTop: "s", 
              paddingBottom: "s",
              zIndex: "1",
              }}
            >
              <Box variant="div">
                <Link 
                  href="https://www.facebook.com/groups/2440673886204303/" 
                  target="_blank"
                >
                  <img 
                    src="/images/social_logos/facebook.png"
                    alt="Facebook"
                    height="45rem"
                    style={{ verticalAlign:"middle", paddingLeft: "10px", paddingRight: "10px", marginBottom: "10px" }}
                  />
                </Link>
                <Link 
                  href="https://www.youtube.com/@frg-formularacinggroup953"
                  target="_blank"
                >
                  <img 
                    src="/images/social_logos/youtube.png"
                    alt="YouTube"
                    height="45rem"
                    style={{ verticalAlign:"middle", paddingLeft: "10px", paddingRight: "10px", marginBottom: "10px" }}
                  />
                </Link>
                <Link 
                  href="https://discord.gg/unEfBYXquy"
                  target="_blank"
                >
                  <img 
                    src="/images/social_logos/discord.png"
                    alt="Discord"
                    height="45rem"
                    style={{ verticalAlign:"middle", paddingLeft: "10px", paddingRight: "10px", marginBottom: "10px" }}
                  />
                </Link>
                {/* <Link 
                  href="https://buy.stripe.com/aEU1635CDcCG8cEaEE" 
                  target="_blank"
                  variant="info" 
                >
                  <div style={{display: "inline-block", height: "100%", verticalAlign: "middle", fontSize: "22px", background: "green", borderRadius: "20px", padding: "7px 20px 7px 20px", color: "white", margin: "0px 10px 10px 10px"}}>
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                      <Icon name="heart" size="medium" />
                      &nbsp; DONATE
                    </div>
                  </div>
                </Link> */}
              </Box>
            </div> 
          <HeroImg />
        </div>
        <div style={{background: awsui.colorBackgroundCellShaded, width: "100%", paddingTop: "20px", paddingBottom: "40px"}}>
          <div className="body-content">
            {/* <div style={{
              color: awsui.colorTextButtonPrimaryActive,
              padding: screenWidth_800? "20px 0px 20px 0px" : "50px 0px 50px 0px",
              borderRadius: "20px",
              fontSize: "16px",
              textAlign: "left"
            }}> */}
            <Grid
              gridDefinition={[
                { colspan: { default: 12, xxs: 10, s: 5, m: 5 } },
                { colspan: { default: 12, xxs: 10, s: 7, m: 7 } },
              ]}
            >
              <Box textAlign="center" >
                <div style={{textAlign: "left", display: "flex", alignContent: "center", paddingBottom: "20px", flexDirection: "column"}}>
                  <center><h4>Tri Nations Esports Cup</h4></center>
                  All racers from the UK, Australia, and New Zealand are invited to compete in the pre-qualification session. Set the fastest time on the Suzuka International Circuit in our qualification servers for a chance to represent your nation in the NextLevel Racing Tri-Nations Esports Cup. Will you be among the elite drivers who secure their spot in the big event?
                </div>
                <Link 
                  href="/trinations-series"
                  onFollow={ (event) => {
                    event.preventDefault();
                    navigate(event.detail.href!)
                  }}
                >
                  <CustomButton
                    type="button"
                    onMouseEnter={ (event:any) => {
                      event.currentTarget.style.filter = `hue-rotate(110deg)`;
                    }}
                    onMouseLeave={ (event:any) => {
                      event.currentTarget.style.filter = "none";
                    }}
                    style={{
                      height: "80px", 
                      width: "100%", 
                      minWidth: "200px",
                      background: awsui.colorBackgroundNotificationRed, 
                      borderRadius: "2px", 
                      alignItems: "center", 
                      color: "white", 
                      fontWeight: "normal", 
                      fontSize: screenWidth_800 ? "24px" : "32px", 
                      borderWidth: "0",
                      lineHeight: "35px",
                    }}
                  >
                    REGISTER NOW
                  </CustomButton>
                </Link>
              </Box>
              <Box>
                <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                  <img 
                    src="/images/trinations-poster.jpg"
                    alt="FRG Name Logo"
                    style={{minWidth: "360px"}}
                  />
                </div>
              </Box>
            </Grid>
          {/* </div>           */}
        </div>
      </div>

        <div style={{background: awsui.colorBackgroundButtonPrimaryActive, width: "100%", paddingTop: "20px", paddingBottom: "40px"}}>
          <div className="body-content">
            <div style={{
              color: awsui.colorTextButtonPrimaryActive,
              padding: screenWidth_800? "20px 0px 20px 0px" : "50px 0px 50px 0px",
              borderRadius: "20px",
              fontSize: "16px",
              textAlign: "left"
            }}>
              <div style={{display: "flex", justifyContent: "center", paddingBottom: "60px"}}>
                <img 
                  src={theme === "light"? "/images/frg-name-horiz-light.png": "/images/frg-name-horiz-dark.png"}
                  alt="FRG Name Logo"
                  style={{minWidth: "360px"}}
                />
              </div>
                <div 
                  style={{
                    color: awsui.colorTextButtonPrimaryActive, 
                    fontSize: "16px",
                    textAlign: "justify",
                  }}>
                    <img
                      src="/images/frg-welcome-img.jpg"
                      alt="Formula Ford Round Winner"
                      width={"90%"}
                      style={{
                        borderRadius: "5px",
                        float: "right",
                        width: "45%",
                        margin: "0px 0px 20px 20px",
                        wordBreak: "break-word",
                      }}
                    />
                    Welcome to FRG E-SPORTS: Australia & New Zealand's Premier Open Wheel Esport League.<p />
                    <br />
                    Discover the ultimate thrill of virtual racing with FRG E-SPORTS, widely recognized as the leading esport league on the renowned iRacing platform. As pioneers of open wheel competition for sim-racers, we have established ourselves as the go-to destination for motorsport enthusiasts throughout Australia and New Zealand.<p />
                    <br />
                    In proud collaboration with esteemed motorsport organizations like Motorsport Australia, Formula Ford Association of Australia, and the FIA, we proudly host official esports championships that attract the fastest open-wheel drivers across the nation. Compete alongside these talented racers as you enjoy one of our exciting social series or vie for the coveted title of official national champion.<p />
                    <br />
                    At FRG, we believe in bridging the gap between virtual and real-world motorsport experiences. By closely aligning our esports championships with actual events, we provide an accessible entry point for drivers and enthusiasts alike to immerse themselves in the thrilling world of motorsport. Experience the adrenaline rush as you race side by side with real-world drivers from their respective championships. Our commitment to authenticity shines through in every aspect of our events. From live race control and dedicated race stewards to in-race penalties and the presence of a specialized FRG-approved safety car, we meticulously replicate the real-world track environment. With weather settings mirroring those found on actual race days, you'll feel the intensity of every lap.<p />
                    <br />
                    Join FRG E-SPORTS today and embrace the unparalleled excitement of online racing. Gain a competitive edge, forge new friendships within our vibrant racing community, and pursue your dreams of motorsport glory.<p />
                  </div>
                
                <Box>
                  <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    
                  </div>
                </Box>
            </div>
            {/* <Box textAlign="center">
              <Link 
                href="/signin"
                onFollow={ (event) => {
                  event.preventDefault();
                  navigate(event.detail.href!)
                }}
              >
                <CustomButton
                  type="button"
                  onMouseEnter={ (event:any) => {
                    event.currentTarget.style.filter = `hue-rotate(110deg)`;
                  }}
                  onMouseLeave={ (event:any) => {
                    event.currentTarget.style.filter = "none";
                  }}
                  style={{
                    height: "80px", 
                    width: "50%", 
                    minWidth: "200px",
                    background: awsui.colorBackgroundNotificationRed, 
                    borderRadius: "2px", 
                    alignItems: "center", 
                    color: "white", 
                    fontWeight: "normal", 
                    fontSize: screenWidth_800 ? "24px" : "32px", 
                    borderWidth: "0",
                    lineHeight: "35px",
                  }}
                >
                  REGISTER NOW
                </CustomButton>
              </Link>
            </Box> */}
          </div>
        </div>
        <div style={{background: awsui.colorBackgroundButtonPrimaryDisabled, width: "100%", paddingTop: "50px", paddingBottom: "50px"}}>
          <div className="body-content">
            <Announcement />
          </div>
        </div>
        <div style={{background: awsui.colorBackgroundCellShaded, width: "100%", paddingTop: "50px", paddingBottom: "50px"}}>
          <div className="body-content">
            {/* <ContentLayout> */}
              <NewsStories />
            {/* </ContentLayout> */}
          </div>
        </div>
        <div style={{background: awsui.colorBackgroundContainerHeader, width: "100%", paddingTop: "50px", paddingBottom: "50px"}}>
          <div className="body-content">
            {/* <ContentLayout> */}
              <CurrentSeries />
            {/* </ContentLayout> */}
          </div>
        </div>
        <div style={{background: "babyblue", width: "100%", paddingTop: "50px", paddingBottom: "50px"}}>
          <div className="body-content">
            {/* <ContentLayout> */}
              <SpaceBetween size="xl">
                <Box>
                  <InfiniteLooper speed={20} direction="left">
                    <div className="loopingContentBlock">
                      <img
                        src={theme === Mode.Light ? "/images/sponsor-logos/djr-logo-dark.png" : "/images/sponsor-logos/djr-logo-light.png"}
                        alt="DJR Logo"
                        width="100%"
                      />
                    </div>
                    <div className="loopingContentBlock">
                      <img
                        src={theme === Mode.Light ? "/images/sponsor-logos/ferodo-racing-logo-dark.png" : "/images/sponsor-logos/ferodo-racing-logo-light.png"}
                        alt="Ferodo Racing Logo"
                        width="100%"
                      />
                    </div>
                    <div className="loopingContentBlock">
                      <img
                        src={theme === Mode.Light ? "/images/sponsor-logos/racekraft-logo-dark.png" : "/images/sponsor-logos/racekraft-logo-light.png"}
                        alt="Racekraft Logo"
                        width="100%"
                      />
                    </div>
                    <div className="loopingContentBlock">
                      <img
                        src={theme === Mode.Light ? "/images/sponsor-logos/racer-ind-logo-dark.png" : "/images/sponsor-logos/racer-ind-logo-light.png"}
                        alt="Racer Industries Logo"
                        width="100%"
                      />
                    </div>
                    <div className="loopingContentBlock">
                      <img
                        src={theme === Mode.Light ? "/images/sponsor-logos/yokohama-logo-dark.png" : "/images/sponsor-logos/yokohama-logo-light.png"}
                        alt="Yokohama Logo"
                        width="100%"
                      />
                    </div>
                    <div className="loopingContentBlock">
                      <img
                        src={theme === Mode.Light ? "/images/ffa-logo-dark.png" : "/images/ffa-logo-light.png"}
                        alt="Formula Ford Logo"
                        width="100%"
                      />
                    </div>
                    <div className="loopingContentBlock">
                      <img  
                        src={theme === Mode.Light ? "/images/sponsor-logos/ma-logo-dark.png" : "/images/sponsor-logos/ma-logo-light.png"}
                        alt="Motorsport Australia Logo"
                        width="100%"
                      />
                    </div>
                    <div className="loopingContentBlock">
                      <img
                        src={theme === Mode.Light ? "/images/sponsor-logos/frg-vert-logo-dark.png" : "/images/sponsor-logos/frg-vert-logo-light.png"}
                        alt="FRG Logo"
                        width="100%"
                      />
                    </div>
                  </InfiniteLooper>
                </Box>
              </SpaceBetween>
            {/* </ContentLayout> */}
          </div>
        </div>
      </center>
    </>    
  );
}
